import AssignmentLateOutlinedIcon from "@mui/icons-material/AssignmentLateOutlined";
import ChangeCircleOutlinedIcon from "@mui/icons-material/ChangeCircleOutlined";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";

export const initialDashboardData = {
  summary: {
    activeOrders: 0,
    checkRequired: 0,
    changeReview: 0,
    deliveryRisk: 0,
    planPending: 0,
  },
  riskDistribution: { NORMAL: 0, ATTENTION: 0, HIGH: 0, OVERDUE: 0 },
  actionItems: [],
  weeklyDue: [],
};

export const kpiConfig = [
  { key: "total", label: "진행 중 전체", helper: "접수부터 보류까지", color: "#334155" },
  { key: "RECEIVED", label: "접수", helper: "확인 시작 전", color: "#2563eb" },
  { key: "CHECKING", label: "확인 중", helper: "주문 조건 확인", color: "#b7791f" },
  { key: "CONFIRMED", label: "확정", helper: "주문 확정 · 진행 전", color: "#0f766e" },
  { key: "IN_PROGRESS", label: "진행", helper: "진행 시작된 주문", color: "#4338ca" },
  { key: "HOLD", label: "보류", helper: "재개 대기", color: "#b45309" },
];

export const quickActions = [
  { title: "주문 목록", path: "orders", icon: <Inventory2OutlinedIcon />, color: "#2563eb" },
  { title: "조치 필요", path: "actions", icon: <AssignmentLateOutlinedIcon />, color: "#f59e0b" },
  { title: "변경 검토", path: "orders?status=CHANGE_REVIEW", icon: <ChangeCircleOutlinedIcon />, color: "#8b5cf6" },
  { title: "납기 위험", path: "orders?riskLevel=DELIVERY_RISK", icon: <ErrorOutlineRoundedIcon />, color: "#ef4444" },
];

export const isEmptyDashboard = (value) => {
  const summaryTotal = Object.values(value?.summary || {}).reduce(
    (sum, count) => sum + Number(count || 0),
    0
  );
  return summaryTotal === 0 && (value?.actionItems || []).length === 0;
};
